import React from 'react'
import '../css/InfoPage.css'
import Chart from '../images/chart.png'
const InfoPage = () => {
  return (
    <div className="infoContainer">
        <div className="info">
          <h1 className="header_yellow">학교소개</h1>
          <h2 className='otherh2'>Reformed Seminary (RS)</h2>
          <p>본교는 1998년 설립되어 전세계에 분포된 대한예수교장로회 총회인준(글로벌 개혁총회)직영 신학교로 칼빈주의적 개혁주의의 전통과 신앙을 계승하고 발전시키며 성경은 일점일획도 가감할 수 없는 정확무오한 하나님의 말씀임을 지켜내는 보수정통의 기치를 높이들고, 자유주의가 난무하는 이시대에 혼합주의와 종교다원주의(W.C.C.W.E.A 동성애)와 세속주의 물결의 시대 풍조에 맞서서 지성과 영성을 겸비한 탁월한 영적 지도자와 사명자를 양성하는 대학교입니다.</p>
          <h2 className='otherh2'>Global Reformed University(GRU)</h2>
          <p>버지니아주 규제및 감독이 면제되는 종교 기관이며, 버지니아 교육부는 GRU의 설립 승인을 2007년 3월에 하였습니다. 뉴욕 캠퍼스에서 공부한 학생들도 대학교 졸업장을 취득하며 박사학위도 전문분야 대로 취득할 수 있습니다. </p>
          <h2 className="redh2">특전</h2>
          <ol>
            <li>NY Campus에서 공부하며 Global Reformed University와 졸업장(주정부 인가 종합대학교)을 받습니다.</li>
            <li>본교가 소속한 총회신학 한국리폼드총회신학대학(원)교(1984년설립)미국 리폼드 대학교 (Reformed University) 연방정부인가 종합대학과의 학점 교류</li>
            <li>다양한 장학금, 총회장, 총회, 선교사, 선교지 후원 장학금</li>
            <li>목회자 사모, 자녀, 특별장학금, 성적 우수장학금</li>
            <li>M.Div 졸업자는 본교단의 강도사 고시 후 목사 임직</li>
            <li>대학원 졸업자는 박사과정 D.Min, Th. D. DRE, DPL, DIS, D. Miss등의 박사학위를 취득</li>
            <li>본국에 2천여 교회가 모이는 보수 장로회 개혁교단</li>
            <li>리쉬마 아카데미 오픈강의(일반인 청강 가능, 뉴욕 예시바 대학 Ph.D교수 직강 실시: 파노라마 신구약 중간사, 제 2차 성전시대 (조기 기독교 및 랍비 유대교)의 역사와 철학, 고대 기독교 교리사 I, II (교부들의 신학사상), 중세 기독교*유대교 역사와 철학, 유대학 개론, 유대인 교육학, 탈무드연구 등.</li>
            <li>예시바 대학과 MOU 체결로 학위 취득</li>
          </ol>
        </div>
        <div className="courseInfo">
            <h2 className="head2">학과목 안내</h2>
            <img className="chart" src={Chart} />
            <p>*박사과정 D Min, Th.D, DRE, DPL, DIS, D Miss</p>
            <div className="lists">
               <ul>
               <li>기독교 영성신학</li>
               <li>영성치유상담학</li>
               <li>설교학</li>
               <li>기초교리학</li>
               <li>구약해석학</li>
               <li>신약해석학</li>
               <li>비교종교학</li>
               <li>기독교교육학(아동)</li>
               <li>기독교음악</li>
               <li>조직신학</li>
                <li>실천신학</li>
                <li>문헌학과 신학</li>
                <li>성경적 세계관</li>
                <li>변증론</li>
               </ul>
               <ul>
               <li>바울신학</li>
                <li>현대목회학</li>
                <li>신구약개론</li>
          <li>헬라어</li>
          <li>히브리어</li>
          <li>장로교회사</li>
          <li>세계교회사</li>
          <li>기독교윤리</li>
          <li>이단연구</li>
          <li>전도학</li>
          <li>예배학</li>
          <li>논문작성법</li>
          <li>선교학</li>
               </ul>
            </div>
        </div>
    </div>
  )
}

export default InfoPage